import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Rounded } from "../../../theme/Rounded";
import { Shadow } from "../../../theme/Shadow";
import { Spacing } from "../../../theme/Spacing";

const Popup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xs};
  width: 15rem;
  padding: ${Spacing.xs};
  border-radius: ${Rounded.lg};
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${Shadow.MD};

  .ant-dropdown-menu {
    box-shadow: none;
    padding: 0;
    max-height: 16rem;
    overflow-y: auto;
  }

  .ant-dropdown-menu-title-content {
    min-width: 0;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: ${Spacing.xs} ${Spacing.s};
  border-radius: ${Rounded.md};
  border: 1px solid ${({ theme }) => theme.darkSub};
  background-color: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.black};
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.main};
  }
`;

type EntryTagsMenuPopupProps = {
  /** The submenu's own list, as the menu renders it */
  menu: React.ReactNode;
  search: string;
  onSearch: (value: string) => void;
  searchTestId: string;
  header?: React.ReactNode;
};

export const EntryTagsMenuPopup: React.FC<EntryTagsMenuPopupProps> = ({
  menu,
  search,
  onSearch,
  searchTestId,
  header,
}) => {
  const { t } = useTranslation();

  return (
    <Popup>
      {header}
      <SearchInput
        autoFocus
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        // The menu moves its highlight on arrow keys and letters, which would
        // swallow what is typed here
        onKeyDown={(e) => e.stopPropagation()}
        placeholder={t("entries.table.entry.tags.search")}
        data-testid={searchTestId}
      />
      {menu}
    </Popup>
  );
};
